module.exports = __webpack_public_path__ + "img/TG.b20f91d3.png";